module.exports = __webpack_public_path__ + "img/6.0373d73e.jpg";